// extracted by mini-css-extract-plugin
export default {"container":"a9uI","sectionContent":"KqQ8","imgWrapper":"GYSM","btnsWrapper":"icCz"};